export default "__VITE_ASSET__DKZK0GVd__"